/* GW Redo skin — restyles the Redo "Checkout+" panel in the cart drawer.
   Not in the original Figma; added at the client's request.

   Redo renders <redo-shopify-toggle> into a CLOSED shadow root, so page CSS
   cannot reach it. attachShadow still returns the root to its caller, so this
   wraps attachShadow (it must run before Redo's script, i.e. before
   {{ content_for_header }} — see layout/theme.liquid) and adopts one
   constructed stylesheet into that element's root. Mode stays closed.

   Nothing is ever added to the root's child list. Redo removes foreign
   children from its root on re-render; an earlier version re-appended a
   <style> each time, the two fought in an endless microtask loop, and the
   page froze on the second add-to-cart. An adopted sheet is not a child, so
   there is nothing for Redo to remove. Redo assigns its own
   adoptedStyleSheets after attachShadow, so the root's setter is wrapped to
   keep ours last in the list. If the browser lacks constructable
   stylesheets, Redo renders with its default look.

   The hooks are Redo's own [data-target] attributes. Colours/fonts come from
   the drawer (--gw-cd-* tokens defined in section-gw-cart-drawer.min.css) and
   inherit through the shadow boundary; fallbacks match those tokens. Redo's
   own dashboard styles use !important, hence the doubled selectors.
   Loaded only when settings.gw_cart_show_redo is on. */
(function () {
  var original = Element.prototype.attachShadow;
  var css = [
    /* protection card */
    "[data-target='info-card-container'][data-target]{display:flex;align-items:center;gap:12px;box-sizing:border-box;width:100%;padding:14px 16px;background:var(--gw-cd-cream,#fdfaf4);border:1px solid #f2ead8;color:var(--gw-cd-label,#252626) !important}",
    "[data-target='info-card-container'][data-target] svg{flex-shrink:0;width:24px;height:24px;color:var(--gw-cd-brown,#6a5632)}",
    "[data-target='text-and-buttons-container'][data-target]{flex:1;min-width:0}",
    "[data-target='toggle-label'][data-target]{display:inline-flex;align-items:center;gap:6px;color:var(--gw-cd-label,#252626) !important;font-size:18px !important;font-weight:400 !important;line-height:1.3 !important}",
    "[data-target='toggle-subtext'][data-target]{display:block;margin-top:2px;color:var(--gw-cd-muted,#555) !important;font-size:14px !important;line-height:1.35 !important}",
    "[data-target='toggle-info-button'][data-target]{color:var(--gw-cd-brown,#6a5632) !important}",
    "[data-target='toggle-info-button'][data-target] svg{width:16px !important;height:16px !important}",
    "[data-target='price'][data-target]{color:var(--gw-cd-brown,#6a5632) !important;font-size:18px !important;font-weight:600 !important;white-space:nowrap}",
    /* buttons */
    "[data-target='checkout-buttons-container'][data-target]{display:flex;flex-direction:column;gap:10px;width:100%;margin-top:12px}",
    "[data-target='coverage-button'][data-target]{width:100% !important;min-height:52px;box-sizing:border-box;padding:10px 16px !important;background:var(--gw-cd-brown,#6a5632) !important;border:0 !important;border-radius:0 !important;color:#fff !important;letter-spacing:.04em;text-transform:uppercase !important;cursor:pointer;transition:background-color .2s ease}",
    "[data-target='coverage-button'][data-target]:hover,[data-target='coverage-button'][data-target]:focus-visible{background:#4a3b1f !important}",
    "[data-target='headline-text-container'][data-target]{color:#fff !important;font-size:18px !important;font-weight:400 !important}",
    "[data-target='subtitle-text-container'][data-target]{color:#fff !important}",
    "[data-target='non-coverage-button'][data-target]{width:100% !important;height:auto !important;min-height:46px;box-sizing:border-box;padding:10px 16px !important;background:transparent !important;border:1px solid var(--gw-cd-brown,#6a5632) !important;border-radius:0 !important;color:var(--gw-cd-brown,#6a5632) !important;font-size:16px !important;cursor:pointer;transition:background-color .2s ease}",
    "[data-target='non-coverage-button'][data-target]:hover,[data-target='non-coverage-button'][data-target]:focus-visible{background:var(--gw-cd-cream,#fdfaf4) !important}",
    "[data-target='coverage-button'][data-target]:focus-visible,[data-target='non-coverage-button'][data-target]:focus-visible{outline:2px solid var(--gw-cd-brown,#6a5632);outline-offset:2px}",
    /* compact footer (pairs with the block at the end of section-gw-cart-drawer.min.css) */
    "[data-target='info-card-container'][data-target]{margin-top:0 !important;padding:10px 14px}",
    "[data-target='checkout-buttons-container'][data-target]{gap:8px;margin-top:8px !important}",
    "[data-target='coverage-button'][data-target]{min-height:48px;margin:0 !important}",
    "[data-target='non-coverage-button'][data-target]{min-height:44px}"
  ].join('\n');
  var adopted = Object.getOwnPropertyDescriptor(ShadowRoot.prototype, 'adoptedStyleSheets');
  if (!adopted || !adopted.set || typeof CSSStyleSheet.prototype.replaceSync !== 'function') return;
  var sheet = new CSSStyleSheet();
  sheet.replaceSync(css);
  function withSkin(sheets) {
    return Array.prototype.filter.call(sheets, function (s) { return s !== sheet; }).concat(sheet);
  }
  Element.prototype.attachShadow = function (init) {
    var root = original.call(this, init);
    if (this.localName === 'redo-shopify-toggle') {
      Object.defineProperty(root, 'adoptedStyleSheets', {
        configurable: true,
        get: function () { return adopted.get.call(root); },
        set: function (sheets) { adopted.set.call(root, withSkin(sheets)); }
      });
      adopted.set.call(root, withSkin(adopted.get.call(root)));
    }
    return root;
  };
})();
